export enum MachineType {
  GPU,
  CPU,
  VGPU,
  NPU,
  TRAINING_GPU,
  INFERENCE_GPU,
  RENDER_GPU,
}

export enum PaymentType {
  Monthly = 1,
  Weekly = 3,
  Daily = 5,
  Hourly = 0,
}

export enum OSType {
  Windows = 1,
  Linux = 3,
}

export enum GhostType {
  Image,
  CustomImage,
  Snapshot,
}

export enum VolumeType {
  DataDrive = 1,
  Snapshot = 2,
  Image = 3,
}

export enum LabelType {
  Instance = 1,
  Snapshot = 2,
}

export enum ExtraPriceType {
  Invalid = 0,
  ExtraDisk = 1,
  ExtraCPU = 2,
  ExtraRAM = 3,
}

export enum MachineResourceCategory {
  GPU = 0,
  CPU = 1,
  VGPU = 2,
  NPU = 3,
  CPUOnly = 4,
  RAMOnly = 5,
  NvSwitch = 6,
  DiskOnly = 7,
}

export const paymentLabel = {
  [PaymentType.Hourly]: 'Hourly',
  [PaymentType.Daily]: 'Daily',
  [PaymentType.Weekly]: 'Weekly',
  [PaymentType.Monthly]: 'Monthly',
}

export const paymentUnit = {
  [PaymentType.Hourly]: 'hour',
  [PaymentType.Daily]: 'day',
  [PaymentType.Weekly]: 'week',
  [PaymentType.Monthly]: 'month',
}

export const paymentHours = {
  [PaymentType.Hourly]: 1,
  [PaymentType.Daily]: 24,
  [PaymentType.Weekly]: 24 * 7,
  [PaymentType.Monthly]: 24 * 30,
}

export enum PortProtocol {
  SSH = 1,
  HTTP = 2,
  VNC = 3,
  RDP = 4,
}

export const portProtocolLabel = {
  [PortProtocol.SSH]: 'SSH',
  [PortProtocol.HTTP]: 'HTTP',
  [PortProtocol.VNC]: 'VNC',
  [PortProtocol.RDP]: 'RDP',
}

export const paymentTerms = {
  [PaymentType.Hourly]: {
    label: 'Hourly',
    unit: 'hour',
    text: 'Billed per hour',
    value: 0,
  },
  [PaymentType.Monthly]: {
    label: 'Monthly',
    unit: 'month',
    text: '30 days',
    value: 30,
  },
  [PaymentType.Weekly]: {
    label: 'Weekly',
    unit: 'week',
    text: '7 days',
    value: 7,
  },

  [PaymentType.Daily]: {
    label: 'Daily',
    unit: 'day',
    text: '1 day',
    value: 1,
  },
}
